import { useQuery } from "@tanstack/react-query";
import { swingCollectionsService } from "../../../services/swingCollections";

/**
 * Fetches top outliers between two collections via POST /api/v1/getOutliers.
 *
 * @param {string[]} primaryCollectionVideoIds - Video IDs for the primary collection
 * @param {string[]} secondaryCollectionVideoIds - Video IDs for the secondary collection
 * @param {{ type: string, value: string } | null} filter - Optional filter (e.g. { type: "keyPosition", value: "ADR" })
 */
export function useGetOutliers(
  primaryCollectionVideoIds,
  secondaryCollectionVideoIds,
  filter,
) {
  const primaryIds = primaryCollectionVideoIds ?? [];
  const secondaryIds = secondaryCollectionVideoIds ?? [];
  const hasIds = primaryIds.length > 0 && secondaryIds.length > 0;

  return useQuery({
    queryKey: [
      "getOutliers_key",
      primaryIds.slice().sort().join(","),
      secondaryIds.slice().sort().join(","),
      filter?.type ?? "",
      filter?.value ?? "",
    ],
    enabled: hasIds,
    queryFn: () => {
      const payload = {
        primaryCollectionVideoIds: primaryIds,
        secondaryCollectionVideoIds: secondaryIds,
      };
      if (filter?.type && filter?.value != null) {
        payload.filter = { type: filter.type, value: filter.value };
      }
      return swingCollectionsService.getOutliers(payload);
    },
    staleTime: 30 * 1000,
  });
}
